<template>
  <div class="registration-header">
    <template>
      <ul class="nav nav-tabs">
        <li
          v-for="(filter, index) in totalRecordCountDetailsCopy"
          :key="index"
          :name="filter.displayFilter"
          role="presentation"
          class="nav-item"
          :class="{ active: regHeaderActivName == filter.displayFilter }"
        >
          <span
            class="icons flex-center nav-link"
            slot="label"
            @click="handleClick(filter.displayFilter)"
            role="tab"
            data-toggle="tab"
          >
            <!-- <img
              v-if="filter.displayFilter == 'View All'"
              src="/static/images/icons/viewall_icon.svg"
              alt
            />
            <img
              v-if="filter.displayFilter == 'Expired'"
              src="/static/images/icons/alert_triangle.svg"
              alt
            />
            <img
              v-else-if="filter.displayFilter == 'Expiring Soon'"
              src="/static/images/icons/expiring_soon.svg"
              alt
            />
            <img
              v-else-if="filter.displayFilter == 'Pending'"
              src="/static/images/icons/pending_icon.svg"
              alt
            />
            <img
              v-else-if="filter.displayFilter == 'In progress'"
              src="/static/images/icons/inprogress_icon.svg"
              alt
            />
            <img
              v-else-if="filter.displayFilter == 'Archive'"
              src="/static/images/icons/archive_icon.svg"
              alt
            /> -->
            <span class="pl-5">{{ translateName(filter.displayFilter) }}</span>
          </span>
        </li>
      </ul>
      <!-- <el-tabs type="border-card" class="elTabs reg_header_tabs" v-model="regHeaderActivName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(filter, index) in totalRecordCountDetails"
          :key="index"
          :name="filter.displayFilter"
        >
          <span class="icons flex-center" slot="label">
             <img
              v-if="filter.displayFilter == 'View All'"
              src="/static/images/icons/viewall_icon.svg"
              alt
            />
            <img
              v-if="filter.displayFilter == 'Expired'"
              src="/static/images/icons/alert_triangle.svg"
              alt
            />
            <img
              v-else-if="filter.displayFilter == 'Expiring Soon'"
              src="/static/images/icons/expiring_soon.svg"
              alt
            />
            <img
              v-else-if="filter.displayFilter == 'Pending'"
              src="/static/images/icons/pending_icon.svg"
              alt
            />
            <img
              v-else-if="filter.displayFilter == 'In progress'"
              src="/static/images/icons/inprogress_icon.svg"
              alt
            />
            <img
              v-else-if="filter.displayFilter == 'Archive'"
              src="/static/images/icons/archive_icon.svg"
              alt
            />
            <span class="filter-count">{{filter.displayFilter+' ('+filter.count+')'}}</span>
          </span>
        </el-tab-pane>
      </el-tabs> -->
    </template>
  </div>
</template>
<script>
export default {
  props: {
    regHeaderActiveName: String,
    totalRecordCountDetails: Array
  },
  data() {
    return {
      regHeaderActivName: this.regHeaderActiveName,
      totalRecordCountDetailsCopy: ''
    };
  },
  watch: {
    regHeaderActiveName() {
      this.regHeaderActivName = this.regHeaderActiveName;
    }
  },
  methods: {
    handleClick(tab) {
      this.$emit('regMenuSelected', tab);
    },
    translateName(name) {
      if (this.$i18n.locale === 'Portuguese') {
        // eslint-disable-next-line no-nested-ternary
        name = name === 'View All' ? 'View_all' : name === 'Expiring Soon' ? 'Expiring_soon' : name;
        const data = {
          View_all: 'Ver Todos',
          Expired: 'Expirados',
          Expiring_soon: 'Expirando Em Breve',
          Pending: 'Pendentes',
          Archive: 'Arquivados'
        };
        return data[name];
      }
      return name;
    }
  },
  created() {
    this.totalRecordCountDetailsCopy = this.totalRecordCountDetails.filter(
      (each) => each.displayFilter !== 'In progress'
    );
  }
};
</script>

<style>
/* .reg_header_tabs.el-tabs--border-card {
  border: none;
  box-shadow: none;
}

.reg_header_tabs.el-tabs--border-card .el-tabs__content {
  padding: 0px;
}

.reg_header_tabs.el-tabs--border-card .el-tabs__header {
  margin: 0px;
  background: #EBEBEB;
}

.reg_header_tabs.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  border-top: 2px solid #C03032;
  margin-top: 0px;
  background: #F5F5F5;
  color: #3E3E3E;
  font-weight: normal;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 0px;
  max-height: 34px;
}

.reg_header_tabs.el-tabs--border-card>.el-tabs__header .el-tabs__item:hover {
  color: #3E3E3E !important;
}

.reg_header_tabs.el-tabs--border-card>.el-tabs__header .el-tabs__item {
  transition: none;
  font-size: 14px;
  color: #3E3E3E;
  padding: 0px 16px;
} */
</style>

<style scoped>
.registration-header {
  margin-left: 75px;
}
/****bootstrap tabs styles ***/
.nav-tabs {
  border-bottom: none;
  background: #ffffff;
}

ul.nav-tabs::after {
  list-style-type: none;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  padding-bottom: 4px;
  border-top: 1px solid #bdbdbd;
}

ul li.nav-item {
  cursor: pointer;
  position: relative;
  text-align: center;
}

li.nav-item.active::after {
  position: absolute;
  content: '';
  height: 3px;
  width: 100%;
  border-bottom: 8px solid #4c9e45;
  background: none;
  left: 3px;
  bottom: 0;
}
.nav-tabs > li.active {
  color: #000000;
  cursor: pointer;
  font-weight: bold !important;
  border: none;
}
ul.nav-tabs > li {
  margin-right: 40px;
  padding-bottom: 12px;
  font-size: 16px;
}
.nav-tabs .icons img {
  width: 18px;
  height: 18px;
}

.filter-count {
  padding: 8px 0px 8px 5px;
  line-height: 18px;
  text-transform: uppercase;
}

.elTabs >>> .icons img {
  width: 16px;
  height: 18px;
}

.flex-center {
  display: flex;
  align-items: center;
}

.nav-tabs .nav-item {
  font-weight: 300;
  color: #000000;
  font-size: 18px;
  line-height: 25px;
}

/* .nav-tabs .nav-item:nth-child(1) {
  margin-left: 2px;
} */

/* .elTabs >>>.el-tabs__item.is-bottom:nth-child(2),
.elTabs >>>.el-tabs__item.is-top:nth-child(2){
  padding-left: 30px;
} */
.p-0 {
  padding: 0;
}
</style>
